import React, { Component } from 'react';
import Powerful_mode_icon from '../../../../../Images/Daikin_Images/image/Heat.png';
import { isEmpty } from '../../../../Common/Common';

export default class Powerful_Mode extends Component {
	constructor(props) {
		super(props);
		let is_enabled = false;
		if (!isEmpty(this.props.point_info)) {
			is_enabled = this.props.point_info.pwfl == 'on';
		}

		this.state = {
			is_enabled: is_enabled
		}
	}

	handlePowerfulMode = () => {
		let pwfl = 'on';
		if (this.state.is_enabled) {
			pwfl = 'off';
			this.setState({ is_enabled: false })
		} else {
			pwfl = 'on';
			this.setState({ is_enabled: true })
		}

		this.props.handlePowerfulMode(pwfl);
	}

	turnOffMode = () => {
		this.setState({ is_enabled: false })
	}

	render() {
		return (
			<div id='powerful_mode' style={this.props.style}>
				<div onClick={this.handlePowerfulMode}>
					<img src={Powerful_mode_icon} style={{ width: 40, opacity: this.state.is_enabled ? 1 : 0.2 }} />
				</div>
				<div>
					<span> {this.props.receiver.getString('powerful_mode')} </span>
				</div>
			</div>
		)
	}
}